import React from "react";
import "../css/AddOfficersInputField.css";
const AddOfficersInputField = ({
  label,
  type = "text",
  value,
  name,
  onChange,
  placeholder,
  min,
  readOnly,
  required,
}) => (
  <div className="add-officer-input-label">
    <label>
      {label}
      {required && <span> *</span>}
    </label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      readOnly={readOnly}
      className="add-officer-input-field"
      min ={min}
      placeholder={placeholder}
      required
    />
  </div>
);

export default AddOfficersInputField;
